import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=f2124610&scoped=true&"
import script from "./MainLayout.vue?vue&type=script&lang=js&"
export * from "./MainLayout.vue?vue&type=script&lang=js&"
import style0 from "./MainLayout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MainLayout.vue?vue&type=style&index=1&id=f2124610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2124610",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2124610')) {
      api.createRecord('f2124610', component.options)
    } else {
      api.reload('f2124610', component.options)
    }
    module.hot.accept("./MainLayout.vue?vue&type=template&id=f2124610&scoped=true&", function () {
      api.rerender('f2124610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/layouts/MainLayout.vue"
export default component.exports